export default __webpack_public_path__ + "static/media/109_mizuo.04f43bbf.png";